export enum FilterActionType {
  AllUsers = 'AllUsers',
  ContainsIssue = 'ContainsIssue',
  DisabledUsers = 'Disabled',
  EnabledUsers = 'Enabled'
}
